import { BareFetcher, SWRConfig, SWRConfiguration } from "swr";
import { SWRFetchError } from "../../utils/hooks/commonly-stored/fetcher";
import { ReactNode } from "react";

export default function FlashPCBSWRConfig({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <SWRConfig
      value={
        {
          revalidateOnFocus: true,
        } as SWRConfiguration<unknown, SWRFetchError, BareFetcher<unknown>>
      }
    >
      {children}
    </SWRConfig>
  );
}
